import { Box, Typography } from '@mui/material';
import { useAuthStore } from '@/stores/authStore';
import { Navigate } from 'react-router-dom';
import { RouteMap } from '@/routes/Routes';
import VideoUpload from './components/VideoUpload';
import { hasBetaProductName } from '@/utils/subscriptionHelpers';
import { useCurrentPlanFeatures } from '@/hooks/useCurrentPlanFeatures';

const VideoUploadPage = () => {
  const { userData } = useAuthStore();
  const { betaFeatures, isLoading: isPlanLoading } = useCurrentPlanFeatures();

  if (!hasBetaProductName(userData) && !betaFeatures.customUploads && !isPlanLoading) {
    return <Navigate to={RouteMap.HOME} replace />;
  }

  // Navigation and error handling are already managed by useVideoUpload hook
  // in VideoPreview component (redirectOnSuccess: true, error state display)
  const handleUploadComplete = (_result: { success: boolean; noteId?: string; filePath?: string; error?: string }) => {
    // Hook handles navigation on success and error display automatically
  };

  return (
    <Box
      px={{ xs: '16px', sm: '32px' }}
      py="24px"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        maxWidth: '900px',
        mx: 'auto',
      }}
    >
      <Typography variant="h4" sx={{ mb: 2, fontWeight: 600 }}>
        Video Uploads
      </Typography>

      <VideoUpload onUploadComplete={handleUploadComplete} />

      <Typography variant="caption" sx={{ color: 'text.secondary', mt: 3 }}>
        Have feedback on beta features? Contact support and mention you're a beta tester.
      </Typography>
    </Box>
  );
};

export default VideoUploadPage;
